import React from 'react'
import {useSelector, useDispatch} from "react-redux";
import {
	_isTransitioningSelector,
	featureTourIsOpenSelector,
	initialZoomInFromStartScreenCompleteSelector,
	showStartScreenSelector
} from "../../Redux/selectors";
import {toggleFeatureTour} from "../../Redux/Actions/uiActions";
import {useCookies} from "react-cookie";

import featureTourContent from '../../content/feature-tour-content/feature-tour-content'

import Tour from 'reactour'
import BigBoldHeader from '../BigBoldHeader'

const USER_HAS_SEEN_FEATURE_TOUR_BEFORE = 'USER_HAS_SEEN_FEATURE_TOUR_BEFORE'
const accentColor = "#5cb7b7"

const steps = featureTourContent.steps.map(({selector, title, text, position = undefined}) => ({
	position,
	selector,
	content: (
		<div>
			{title && <BigBoldHeader headerText={title} />}
			{text && <p>{text}</p>}
			<div className="tiny-italic-gray-text">
				For questions or issue: <a href="mailto: mapping@ruralinnovation.us">mapping@ruralinnovation.us</a>
			</div>
		</div>
	)
}))

const FeatureTour = React.memo(
	() => {
		const dispatch = useDispatch()
		const featureTourIsOpen = useSelector(featureTourIsOpenSelector)
		const showStartScreen = useSelector(showStartScreenSelector)
		const _isTransitioning = useSelector(_isTransitioningSelector)
		const initialZoomInFromStartScreenComplete = useSelector(initialZoomInFromStartScreenCompleteSelector)
		const [cookies, setCookie] = useCookies([USER_HAS_SEEN_FEATURE_TOUR_BEFORE]);
		
		const closeTour = () => {
			dispatch(toggleFeatureTour(false))
			
			if (!cookies[USER_HAS_SEEN_FEATURE_TOUR_BEFORE]) {
				setCookie(USER_HAS_SEEN_FEATURE_TOUR_BEFORE, true)
			}
		}
		
		const validMomentToShowTour = initialZoomInFromStartScreenComplete && !showStartScreen && !_isTransitioning
		const showTour = validMomentToShowTour && (!cookies[USER_HAS_SEEN_FEATURE_TOUR_BEFORE] || featureTourIsOpen)
		
		return (
				<div>
					<Tour
						onRequestClose={closeTour}
						lastStepNextButton={<div className="tour-last-step-button" onClick={closeTour}>To the map!</div>}
						steps={steps}
						isOpen={showTour}
						maskClassName="mask"
						className="helper"
						rounded={5}
						accentColor={accentColor}
						scrollOffset={-300}
						scrollDuration={1000}
					/>
				</div>
		)
	}
)


export default FeatureTour
